import React from "react";
import ReactDOM from "react-dom/client";

import Admin from "../src/pages/index";

ReactDOM.createRoot(document.getElementById("root")!).render(<Admin />);
